export default __webpack_public_path__ + "media/triangle-shape.1d5ddacc.svg";